package br.com.vvrefeicoes.portal.feature.legal

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import com.composables.icons.lucide.ArrowLeft
import com.composables.icons.lucide.Lucide
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.privacy_back
import portalvv.shared.generated.resources.privacy_s10_body
import portalvv.shared.generated.resources.privacy_s10_title
import portalvv.shared.generated.resources.privacy_s11_body
import portalvv.shared.generated.resources.privacy_s11_title
import portalvv.shared.generated.resources.privacy_s12_body
import portalvv.shared.generated.resources.privacy_s12_title
import portalvv.shared.generated.resources.privacy_s13_body
import portalvv.shared.generated.resources.privacy_s13_title
import portalvv.shared.generated.resources.privacy_s14_body
import portalvv.shared.generated.resources.privacy_s14_title
import portalvv.shared.generated.resources.privacy_s15_body
import portalvv.shared.generated.resources.privacy_s15_title
import portalvv.shared.generated.resources.privacy_s16_body
import portalvv.shared.generated.resources.privacy_s16_title
import portalvv.shared.generated.resources.privacy_s17_body
import portalvv.shared.generated.resources.privacy_s17_title
import portalvv.shared.generated.resources.privacy_s18_body
import portalvv.shared.generated.resources.privacy_s18_title
import portalvv.shared.generated.resources.privacy_s1_body
import portalvv.shared.generated.resources.privacy_s1_title
import portalvv.shared.generated.resources.privacy_s2_body
import portalvv.shared.generated.resources.privacy_s2_title
import portalvv.shared.generated.resources.privacy_s3_body
import portalvv.shared.generated.resources.privacy_s3_title
import portalvv.shared.generated.resources.privacy_s4_body
import portalvv.shared.generated.resources.privacy_s4_title
import portalvv.shared.generated.resources.privacy_s5_body
import portalvv.shared.generated.resources.privacy_s5_title
import portalvv.shared.generated.resources.privacy_s6_body
import portalvv.shared.generated.resources.privacy_s6_title
import portalvv.shared.generated.resources.privacy_s7_body
import portalvv.shared.generated.resources.privacy_s7_title
import portalvv.shared.generated.resources.privacy_s8_body
import portalvv.shared.generated.resources.privacy_s8_title
import portalvv.shared.generated.resources.privacy_s9_body
import portalvv.shared.generated.resources.privacy_s9_title
import portalvv.shared.generated.resources.privacy_title
import portalvv.shared.generated.resources.privacy_updated_at

private const val BLOCK_SEPARATOR = "||"

private val privacySections =
    listOf(
        Res.string.privacy_s1_title to Res.string.privacy_s1_body,
        Res.string.privacy_s2_title to Res.string.privacy_s2_body,
        Res.string.privacy_s3_title to Res.string.privacy_s3_body,
        Res.string.privacy_s4_title to Res.string.privacy_s4_body,
        Res.string.privacy_s5_title to Res.string.privacy_s5_body,
        Res.string.privacy_s6_title to Res.string.privacy_s6_body,
        Res.string.privacy_s7_title to Res.string.privacy_s7_body,
        Res.string.privacy_s8_title to Res.string.privacy_s8_body,
        Res.string.privacy_s9_title to Res.string.privacy_s9_body,
        Res.string.privacy_s10_title to Res.string.privacy_s10_body,
        Res.string.privacy_s11_title to Res.string.privacy_s11_body,
        Res.string.privacy_s12_title to Res.string.privacy_s12_body,
        Res.string.privacy_s13_title to Res.string.privacy_s13_body,
        Res.string.privacy_s14_title to Res.string.privacy_s14_body,
        Res.string.privacy_s15_title to Res.string.privacy_s15_body,
        Res.string.privacy_s16_title to Res.string.privacy_s16_body,
        Res.string.privacy_s17_title to Res.string.privacy_s17_body,
        Res.string.privacy_s18_title to Res.string.privacy_s18_body,
    )

@Composable
fun PrivacyPolicyScreen(onBack: () -> Unit = {}) {
    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space24),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Column(
            modifier = Modifier.widthIn(max = 840.dp).fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Text(
                    text = stringResource(Res.string.privacy_title),
                    style = MaterialTheme.typography.headlineMedium,
                )
                AppButton(
                    text = stringResource(Res.string.privacy_back),
                    onClick = onBack,
                    variant = PortalButtonVariant.Text,
                    leadingIcon = Lucide.ArrowLeft,
                )
            }
            Text(
                text = stringResource(Res.string.privacy_updated_at),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            privacySections.forEachIndexed { index, section ->
                PrivacySection(number = index + 1, title = section.first, body = section.second)
            }
        }
    }
}

@Composable
private fun PrivacySection(
    number: Int,
    title: StringResource,
    body: StringResource,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
        Text(
            text = "$number. ${stringResource(title)}",
            style = MaterialTheme.typography.titleMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
        policyBlocks(body).forEach { block ->
            Text(
                text = block,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}

@Composable
private fun policyBlocks(resource: StringResource): List<String> =
    stringResource(resource)
        .split(BLOCK_SEPARATOR)
        .map { it.trim() }
        .filter { it.isNotEmpty() }
